module.exports = __webpack_public_path__ + "static/img/COSTA.65494c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/COSTA.png
// module id = d3sR
// module chunks = 34